// Authentication utility functions

const TOKEN_KEY = 'openhosst_auth_token';
const USER_KEY = 'openhosst_user';

// Store authentication token
export const setAuthToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

// Get authentication token
export const getAuthToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// Remove authentication token
export const removeAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Store user data
export const setUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

// Get user data
export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

// Check if user is authenticated. Also treats an EXPIRED token as unauthenticated
// (and clears it), so a stale session redirects to login instead of loading a page
// whose API calls then fail with a confusing "Failed to load..." error.
export const isAuthenticated = () => {
  const token = getAuthToken();
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (payload && payload.exp && payload.exp * 1000 <= Date.now()) {
      removeAuthToken();
      return false;
    }
  } catch (_) {
    // Malformed token — leave it; the server will reject it and the axios
    // interceptor below will handle the redirect.
  }
  return true;
};

// Check if the authenticated user has verified their email
export const isEmailVerified = () => {
  const user = getUser();
  return !!(user && user.emailVerified);
};

// Create axios config with auth header
export const getAuthConfig = () => {
  const token = getAuthToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

// Logout user
export const logout = () => {
  removeAuthToken();
};

// Service management
const SERVICE_KEY = 'openhosst_current_service';

export const setCurrentService = (service) => {
  localStorage.setItem(SERVICE_KEY, service);
};

export const getCurrentService = () => {
  return localStorage.getItem(SERVICE_KEY) || 'n8n';
};

// Helper to get service base path
export const getServicePath = (service) => {
  return `/${service || getCurrentService()}`;
};
